import { useState, useRef, useEffect } from 'react';
import axios from 'axios';

const API = 'https://weridesudan.com/api/admin';

interface Message {
  role: 'user' | 'assistant';
  text: string;
}

export default function AIAssistant({ token }: { token: string }) {
  const [messages, setMessages] = useState<Message[]>([
    { role: 'assistant', text: 'Hello! I am your WeRide Sudan AI assistant. Ask me anything about your rides, drivers, or riders.' }
  ]);
  const [input, setInput] = useState('');
  const [loading, setLoading] = useState(false);
  const bottomRef = useRef<HTMLDivElement>(null);

  useEffect(() => { bottomRef.current?.scrollIntoView({ behavior: 'smooth' }); }, [messages]);

  const sendMessage = async () => {
    if (!input.trim() || loading) return;
    const userMsg = input.trim();
    setInput('');
    setMessages(prev => [...prev, { role: 'user', text: userMsg }]);
    setLoading(true);
    try {
      const headers = { Authorization: `Bearer ${token}` };
      const statsRes = await axios.get(`${API}/stats`, { headers });
      const context = { stats: statsRes.data };
      const res = await axios.post(`${API}/ai`, { message: userMsg, context }, { headers });
      setMessages(prev => [...prev, { role: 'assistant', text: res.data.reply }]);
    } catch(err: any) {
      setMessages(prev => [...prev, { role: 'assistant', text: 'Error: ' + (err.message || 'Something went wrong') }]);
    }
    setLoading(false);
  };

  return (
    <div style={{ padding: 20, height: '100%', display: 'flex', flexDirection: 'column' }}>
      <h2>🤖 AI Assistant</h2>
      <div style={{ flex: 1, overflowY: 'auto', padding: 16, background: '#f5f5f5', borderRadius: 8, marginBottom: 16, minHeight: 300 }}>
        {messages.map((m, i) => (
          <div key={i} style={{ display: 'flex', justifyContent: m.role === 'user' ? 'flex-end' : 'flex-start', marginBottom: 12 }}>
            <div style={{ maxWidth: '70%', padding: '10px 14px', borderRadius: 12, background: m.role === 'user' ? '#1a73e8' : '#fff', color: m.role === 'user' ? '#fff' : '#333', boxShadow: '0 1px 3px rgba(0,0,0,0.1)' }}>
              {m.text}
            </div>
          </div>
        ))}
        {loading && <div style={{ textAlign: 'center', color: '#999' }}>Thinking...</div>}
        <div ref={bottomRef} />
      </div>
      <div style={{ display: 'flex', gap: 8 }}>
        <input value={input} onChange={e => setInput(e.target.value)} onKeyDown={e => e.key === 'Enter' && sendMessage()} placeholder="Ask about your rides, drivers, revenue..." style={{ flex: 1, padding: '10px 14px', borderRadius: 8, border: '1px solid #ddd', fontSize: 14 }} />
        <button onClick={sendMessage} disabled={loading} style={{ padding: '10px 20px', background: '#1a73e8', color: '#fff', border: 'none', borderRadius: 8, cursor: 'pointer', fontSize: 14 }}>Send</button>
      </div>
    </div>
  );
}
